import script from "./TarefasManeger.vue?vue&type=script&setup=true&lang=js"
export * from "./TarefasManeger.vue?vue&type=script&setup=true&lang=js"

import "./TarefasManeger.vue?vue&type=style&index=0&id=3b2aa700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b2aa700"]])

export default __exports__